import React, { useState } from 'react';
import { Box, MenuItem, TextField } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useFormContext } from '../FormContext';
import ConfigCard from './components/ConfigCard';
import ConfigContent from './components/ConfigContent';
import ConfigFieldControl from './components/ConfigFieldControl';
import ConfigHeader from './components/ConfigHeader';
import FormSchemaFieldCreateDialog from '../dialogs/FormSchemaFieldCreateDialog';
export const FormConfigDataSource = () => {
    const { formState, entitySchema, updateElement, elementPlugins } = useFormContext();
    const [openDialog, setOpenDialog] = useState(false);
    const element = formState.selectedFormElement;
    const hasSchemaColumns = (entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.columns) && entitySchema.columns.length > 0;
    const plugin = elementPlugins.find(p => p.type === element.type);
    let columns = (entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.columns) || [];
    if (plugin === null || plugin === void 0 ? void 0 : plugin.dataTypes) {
        // if plugin specifies limited data types filter to only display available
        // columns
        columns = columns.filter(column => plugin.dataTypes.includes(column.type));
    }
    return (React.createElement(ConfigCard, null,
        React.createElement(ConfigHeader, null, "Data Configuration"),
        React.createElement(ConfigContent, null,
            React.createElement(ConfigFieldControl, null,
                React.createElement(TextField, { fullWidth: true, select: hasSchemaColumns, disabled: !hasSchemaColumns, variant: 'outlined', label: 'Schema Field', value: element.dataSource || '', onChange: event => {
                        const dataSource = event.target.value;
                        if (dataSource === '{add-new}') {
                            // add new field schema
                            setOpenDialog(true);
                        }
                        else {
                            updateElement({ dataSource });
                        }
                    } },
                    columns.map(column => (React.createElement(MenuItem, { key: column.name, value: column.name }, column.displayName))),
                    React.createElement(MenuItem, { value: '{add-new}' }, "+ Add New Field")),
                !hasSchemaColumns && (React.createElement(Box, { mt: 1 },
                    React.createElement(Alert, { severity: 'info' }, "No schema fields defined. You can assign schema fields in the schema editor tab."))))),
        openDialog && (React.createElement(FormSchemaFieldCreateDialog, { open: true, onCancel: () => setOpenDialog(false), onAdded: dataSource => {
                updateElement({ dataSource });
                setOpenDialog(false);
            } }))));
};
export default FormConfigDataSource;
//# sourceMappingURL=FormConfigDataSource.js.map